import React from 'react';
import NewsListWithTitle from './NewsListWithTitle';
import s from '../styles/News.module.css';
import tabPanel from '../styles/TabPanel.module.css';
import { cleanCourseName } from '@Util/util';

type NewsContent = {
    id: number;
    title: string;
    date: string;
};

type NewsProps = {
    show: boolean;
    news: NewsContent[];
    courseName: string;
};

export const News = (props: NewsProps) => {
    return (
        <div className={`${s.container} ${props.show ? '' : tabPanel.tab_panel_hidden}`}>
            <NewsListWithTitle
                title={`${cleanCourseName(props.courseName)}からのお知らせ`}
                contents={props.news}
                isStaffBlog={false}
            />
        </div>
    );
};

export default News;
